export default (el, to = 0, d = 1250, cb) => {
	let cos   = (el.scrollTop - to) / 2,
		count = 0,
		oTime = window.performance.now(),
		s = nTime => {
			let tsDiff = nTime - oTime,
				pos    = 0
			// Performance.now() polyfill loads late so passed-in timestamp is a larger offset
			// on the first go-through than we want so I'm adjusting the difference down here.
			// Regardless, we would rather have a slightly slower animation than a big jump so a good
			// safeguard, even if we're not using the polyfill.
			if (100 < tsDiff) {
				tsDiff = 30
			}
			count += Math.PI / (d / tsDiff)

			// As soon as we cross over Pi, we're about where we need to be
			if (count >= Math.PI) {
				if (to !== el.scrollTop) {
					el.scrollTop = to
				}
				if ('function' === typeof cb) {
					cb()
				}
				return
			}

			pos = Math.round(to + cos + cos * Math.cos(count))
			el.scrollTop = pos
			oTime = nTime
			requestAnimationFrame(s)
		}

	// Let's scroll!
	requestAnimationFrame(s)
}